/**
 * クリックと同じタイミングで別ウィンドウを確保する。
 * 参加 URL の発行を待ってから window.open すると、ブラウザのポップアップ制限に止められる。
 */
export function openCallWindow(): Window | null {
  const target = window.open(
    "",
    "_blank",
    "width=1280,height=800,resizable=yes,scrollbars=yes",
  );
  if (!target) return null;
  try {
    target.opener = null;
    target.document.title = "通話を準備しています";
    target.document.body.style.cssText =
      "margin:0;display:grid;min-height:100vh;place-items:center;font-family:system-ui,sans-serif;background:#0f172a;color:#fff";
    const message = target.document.createElement("p");
    message.textContent = "通話を準備しています…";
    target.document.body.replaceChildren(message);
  } catch {
    // about:blank の準備表示に失敗しても、取得したウィンドウは参加 URL へ遷移できる。
  }
  return target;
}

export function openCallJoinUrl(target: Window, joinUrl: string): void {
  if (target.closed) return;
  target.location.replace(joinUrl);
  target.focus();
}

/** 自社通話画面を別ウィンドウに表示し、元の業務画面を維持する。 */
export function openCallPage(target: Window, conversationId: string, meetingId: string): void {
  if (target.closed) return;
  const query = new URLSearchParams({ conversationId });
  target.location.replace(`/chat/call/${encodeURIComponent(meetingId)}?${query.toString()}`);
  target.focus();
}
